// extracted by mini-css-extract-plugin
export default {"row":"createTask_row__cV0+F","col":"createTask_col__a0e8F","card":"createTask_card__cf9fe"};